import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { AuthPending } from "@/components/signin/auth-card";
import { CodeStep } from "@/components/signin/code-step";
import { useSigninT } from "@/components/signin/signin-i18n";
import { parseAuthSearch, readPendingSignIn } from "@/lib/auth-flow";

export const Route = createFileRoute("/code")({
	validateSearch: parseAuthSearch,
	component: CodeScreen,
});

/**
 * Экран ввода кода (макет 4a, карточки 2 и 4).
 *
 * Адрес почты берётся из `sessionStorage`, а не из адресной строки: в URL он
 * попал бы в историю браузера, в реферер и в логи прокси. Отсюда же следует
 * поведение при прямом заходе на `/code`: показывать нечего — молча уводим
 * на первый шаг, сохраняя параметры OIDC.
 */
function CodeScreen() {
	const search = Route.useSearch();
	const navigate = useNavigate();
	const t = useSigninT();

	// Снимок на весь экран: `CodeStep` дальше ведёт сроки сам, и подмена
	// `pending` под ним посреди отсчёта сбросила бы таймеры.
	const [pending] = useState(readPendingSignIn);

	useEffect(() => {
		if (!pending) void navigate({ to: "/", search, replace: true });
	}, [pending, navigate, search]);

	if (!pending) return <AuthPending label={t("email.checkingSession")} />;

	return <CodeStep search={search} pending={pending} />;
}
